import { __assign, __rest } from "tslib";
import React from 'react';
import { TreeItem as SourceTreeItem, treeItemClasses } from '@mui/x-tree-view';
import { FlexRow } from '../layout/FlexRow';
import { FlexColumn } from '../layout/FlexColumn';
import Box from '@mui/material/Box';
import { Typography } from './Typography';
import { styled } from '@mui/material/styles';
import { colors } from '../../theme';
import { Label } from './Label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
var StyledTreeItemRoot = styled(SourceTreeItem)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(treeItemClasses.content)] = {
            borderBottom: "1px solid ".concat(colors.gray[20]),
            minHeight: '53px',
            paddingTop: '10px',
            paddingBottom: '9px',
            '&:hover': {
                backgroundColor: colors.white
            },
            '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
                backgroundColor: colors.blue[10],
                color: '#222945'
            }
        },
        _b["& .".concat(treeItemClasses.label)] = {
            fontWeight: '400',
            color: '#222945',
            fontFamily: 'IBM Plex Sans',
            fontSize: '16px'
        },
        _b["& .".concat(treeItemClasses.iconContainer)] = {
            color: '#545B71',
            fontSize: '10px',
            '& .close': {
                opacity: 0.3
            }
        },
        _b["& .".concat(treeItemClasses.group)] = {
            marginLeft: 15,
            paddingLeft: 18
        },
        _b);
});
function StyledTreeItem(props) {
    var LabelIcon = props.labelIcon, 
    // labelInfo,
    labelText = props.labelText, isGranted = props.isGranted, caption = props.caption, other = __rest(props, ["labelIcon", "labelText", "isGranted", "caption"]);
    return (React.createElement(StyledTreeItemRoot, __assign({ label: React.createElement(FlexColumn, { style: { width: '100%' } },
            React.createElement(FlexRow, { alignItems: 'center', style: {
                    padding: 0.5,
                    paddingRight: 0,
                    width: '100%'
                }, columnGap: '8px', justifyContent: 'space-between' },
                React.createElement(FlexRow, null,
                    React.createElement(Box, { color: "inherit", sx: { mr: 1 } }, LabelIcon ? LabelIcon : null),
                    React.createElement(FlexColumn, null,
                        React.createElement(Typography, { variant: 'body-regular', style: { color: '#222945', fontSize: '16px' } }, labelText),
                        React.createElement(Typography, { variant: 'caption-regular' }, caption))),
                isGranted ?
                    React.createElement(Label, { variant: 'success', icon: React.createElement(FontAwesomeIcon, { size: 'lg', icon: faBadgeCheck, color: '#94BD91' }), width: '33px' })
                    : null)) }, other)));
}
// export interface StyledTreeItemProps extends TreeItemProps {
//     /** The order in which the item will be shown. */
//     nodeId: string
//     /** A text label for the item. */
//     label?: string | undefined
//     /** Expand icon */
//     expandIcon?: any
//     /** End icon */
//     endIcon?: any
//     /** An optional icon to be shown at the start of the label. */
//     icon?: any
// }
export var TreeItem = function (_a) {
    var nodeId = _a.nodeId, labelText = _a.labelText, labelIcon = _a.labelIcon, props = __rest(_a, ["nodeId", "labelText", "labelIcon"]);
    return React.createElement(StyledTreeItem, __assign({ nodeId: nodeId, labelText: labelText, labelIcon: labelIcon }, props));
};
